import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { OhioTitleApplicationPacketDto } from 'dtos/vehicles/titles'
import { concatAddress, formatDateMoment } from 'utils'

interface Props {
  values?: OhioTitleApplicationPacketDto
}

export default function OhioTitleApplicationPacketCard({ values }: Props) {
  return (
    <Card variant='outlined'>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto'>
              <Typography fontWeight='bold' variant='h5'>
                Ohio Title Application Packet
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item sm={12} md={3} container spacing={1}>
            <Grid item xs={12}>
              <LabelField label='Seller Name' value={values?.ohioTitleSellerName} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Seller Address' value={values?.ohioTitleSellerAddress1} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Seller City' value={values?.ohioTitleSellerCity} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Seller County' value={values?.ohioTitleSellerCounty} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Seller State/Province' value={values?.ohioTitleSellerStateProvince} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Seller Postal Code' value={values?.ohioTitleSellerPostalCode} />
            </Grid>
          </Grid>

          <Grid item sm={12} md={3} container spacing={1}>
            <Grid item xs={12}>
              <LabelField label='Owner Name' value={values?.ohioTitleOwnerName} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner Address' value={values?.ohioTitleOwnerAddress1} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner City' value={values?.ohioTitleOwnerCity} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner County' value={values?.ohioTitleOwnerCounty} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner State/Province' value={values?.ohioTitleOwnerStateProvince} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner Postal Code' value={values?.ohioTitleOwnerPostalCode} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner IRS #' value={values?.ohioTitleOwnerIrsNumber} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Owner Dealer #' value={values?.ohioTitleOwnerDealerNumber} />
            </Grid>
          </Grid>

          <Grid item sm={12} md={3} container spacing={1}>
            <Grid item xs={12}>
              <LabelField label='Inspection Company' value={values?.ohioTitleInspectionCompany} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Inspection Company Address' value={values?.ohioTitleInspectionCompanyAddress1} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Inspection Company City' value={values?.ohioTitleInspectionCompanyAddressCity} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Inspection Company Country' value={values?.ohioTitleInspectionCompanyAddressCountry} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Inspection Company State/Province' value={values?.ohioTitleInspectionCompanyAddressStateProvince} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Inspection Company Postal Code' value={values?.ohioTitleInspectionCompanyAddressPostalCode} />
            </Grid>
          </Grid>

          <Grid item sm={12} md={3} container spacing={1}>
            <Grid item xs={12}>
              <LabelField label='Document Signer' value={values?.ohioTitleDocumentSignerPerson} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Title Clerk' value={values?.ohioTitleTitleClerkPerson} />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Odometer Disclosure Statement Mileage'
                value={values?.ohioTitleOdometerDisclosureStatementMileage ? `${values?.ohioTitleOdometerDisclosureStatementMileage} MI` : undefined}
              />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Vehicle Purchase Agreement Effective Date' value={formatDateMoment(values?.ohioTitleVehiclePurchaseAgreementEffectiveDate)} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Lien Holder Company' value={values?.ohioTitleLienHolderCompany} />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Lien Holder Company Address'
                value={concatAddress(
                  values?.ohioTitleLienHolderCompanyAddress1,
                  values?.ohioTitleLienHolderCompanyAddress2,
                  values?.ohioTitleLienHolderCompanyAddressCity,
                  values?.ohioTitleLienHolderCompanyAddressStateProvince,
                  values?.ohioTitleLienHolderCompanyAddressPostalCode
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Application Packet Ready For Build A Box'
                value={
                  values?.ohioTitleApplicationPacketReadyForBuildABoxDateTime
                    ? `
                  ${formatDateMoment(values?.ohioTitleApplicationPacketReadyForBuildABoxDateTime)} by ${
                        values?.ohioTitleApplicationPacketReadyForBuildABoxByPerson ?? '<User>'
                      }`
                    : undefined
                }
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Ohio Title Application Packet Card:**

All fields on this card are populated automatically from the saved Ohio Title Application Packet for the vehicle. These fields are read-only and cannot be edited on this screen. They reflect the information submitted with the Title Application and are displayed for reference purposes only.`}
            </GreenText>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
